module.exports = __webpack_public_path__ + "img/ocean.1d380141.svg";